import isMobile from '../util/isMobile';

let alertModule: any = {}

if (isMobile()) {
	alertModule = window;
} else {
	alertModule = window;
	// alertModule = alertify;
}

let Alert:any = {}

if (window.parent.length === 0) {
	Alert = {
		log(msg: string) {
			alertModule.alert(msg);
		},
		error(msg: string) {
			alertModule.alert(msg);
		},
		confirm(msg: string, callback: any, item?: any) {
			let result = alertModule.confirm(msg);
			if (result) {
				callback();
			}
		}
	}
} else {
	Alert = {
		log(msg: string) {
			window.parent.postMessage({ msg: 'alert', type: 'log', data: msg }, '*');
		},
		error(msg: string) {
			window.parent.postMessage({ msg: 'alert', type: 'error', data: msg }, '*');
		},
		confirm(msg: string, callback: any, item?: any) {
			let result = alertModule.confirm(msg);
			if (result) {
				callback();
			}
		}
	}
}

export default Alert;